var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { WMLogger } from '@mobilize/logging';
import { Order } from '../../../Contract';
import { ErrorCodes, ExceptionHandlerClass } from '../../../System/Aop';
var ReferenceBehavior = (function () {
    function ReferenceBehavior() {
    }
    ReferenceBehavior.prototype.apply = function (model, root) {
        if (!model || !model.references) {
            return;
        }
        this.addReferences(model, model.references, root);
    };
    ReferenceBehavior.prototype.addReferences = function (model, references, buffer) {
        for (var refName in references) {
            if (references.hasOwnProperty(refName)) {
                var adjacent = buffer.getModel(references[refName]);
                if (adjacent) {
                    model.addReference(refName, adjacent);
                    adjacent.addReferencedBy(model.UniqueID, refName);
                }
                else {
                    WMLogger.instance().warn("warn. The model ".concat(model, " does not have a reference with the name:,\n                    ").concat(refName, ". This is possibly an error in the response of the back end"));
                }
            }
        }
    };
    Object.defineProperty(ReferenceBehavior.prototype, "Order", {
        get: function () {
            return Order.ORD;
        },
        enumerable: false,
        configurable: true
    });
    ReferenceBehavior = __decorate([
        ExceptionHandlerClass(ErrorCodes.ClientCore)
    ], ReferenceBehavior);
    return ReferenceBehavior;
}());
export { ReferenceBehavior };
